import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "./styles.css";

const UsersByPlanDetailModal = ({ isOpen, onClose, user }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const servicesPerPage = 5;
    const services = useMemo(() => user?.memberships || [], [user]);
    const totalPages = Math.ceil(services.length / servicesPerPage);
    const startIndex = (currentPage - 1) * servicesPerPage;
    const endIndex = startIndex + servicesPerPage;
    const currentServices = useMemo(() => services.slice(startIndex, endIndex), [services, startIndex, endIndex]);

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [user, isOpen]);

    if (!user) return null;

    return (
        <Modal show={isOpen} onHide={onClose} centered scrollable size="sm" className="users-plan-panel-detail-modal justify-content-center">
            <Modal.Header>
                <Modal.Title className="users-plan-panel-detail-modal-title w-100 text-center">
                    Número de accesos del plan
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column align-items-center gap-2">
                <div className="text-center">
                    <div className="users-plan-panel-detail-modal-labels">{user.customer_email}</div>
                    <div className="users-plan-panel-detail-modal-labels">{user.customer_phone || '---'}</div>
                </div>

                <table className="table table-bordered text-center w-75 users-plan-panel-detail-modal-labels">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Servicio</th>
                        <th>Accesos Restantes</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentServices.map((membership, index) => (
                        <tr key={startIndex + index}>
                            <td>{startIndex + index + 1}</td>
                            <td>{membership.service_name || membership.plan_name}</td>
                            <td>{membership.remaining_quota !== -1 ? membership.remaining_quota : 'Ilimitados'}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>

                <div className="d-flex justify-content-end align-items-center gap-4 w-75">
                    <span className="plans-list-panel-table-labels">
                        {services.length > 0 ? `${startIndex + 1} - ${Math.min(endIndex, services.length)} de ${services.length}` : '0 de 0'}
                    </span>
                    <div className="d-flex gap-2">
                        <svg
                            className={`bi bi-chevron-left ${currentPage === 1 ? 'text-muted' : 'cursor-pointer'}`}
                            onClick={currentPage === 1 ? undefined : handlePrevPage}
                            xmlns="http://www.w3.org/2000/svg" width="9" height="15"
                            viewBox="0 0 9 15" fill="none"
                            style={{ pointerEvents: currentPage === 1 ? 'none' : 'auto' }}
                        >
                            <path d="M0.0423059 7.30351C0.0423059 6.92015 0.188535 6.53675 0.481072 6.24419L6.28647 0.438753C6.87147 -0.146251 7.81998 -0.146251 8.405 0.438753C8.99 1.02376 8.99 1.97231 8.405 2.55733L3.65881 7.30351L8.405 12.0497C8.99 12.6347 8.99 13.5832 8.405 14.1683C7.81998 14.7533 6.87147 14.7533 6.28647 14.1683L0.481072 8.36282C0.188535 8.0703 0.0423059 7.68685 0.0423059 7.30351Z" fill="#9DACBD"/>
                        </svg>
                        <svg
                            className={`bi bi-chevron-right ${currentPage === totalPages || totalPages === 0 ? 'text-muted' : 'cursor-pointer'}`}
                            onClick={currentPage === totalPages ? undefined : handleNextPage}
                            xmlns="http://www.w3.org/2000/svg" width="10" height="15"
                            viewBox="0 0 10 15" fill="none"
                            style={{ pointerEvents: currentPage === totalPages || totalPages === 0 ? 'none' : 'auto' }}
                        >
                            <path d="M9.67644 7.30196C9.67644 7.68532 9.53022 8.06872 9.23768 8.36128L3.43228 14.1667C2.84728 14.7517 1.89877 14.7517 1.31375 14.1667C0.72875 13.5817 0.72875 12.6332 1.31375 12.0481L6.05994 7.30196L1.31375 2.55578C0.72875 1.97078 0.72875 1.02223 1.31375 0.437193C1.89877 -0.14781 2.84728 -0.14781 3.43228 0.437193L9.23768 6.24264C9.53022 6.53517 9.67644 6.91862 9.67644 7.30196Z" fill="#9DACBD"/>
                        </svg>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <Button
                    variant="primary"
                    className="users-plan-panel-detail-modal-button"
                    onClick={onClose}
                >
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UsersByPlanDetailModal;
